import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button } from '@calm-web/design-system';

export const Container = styled.div`
	width: 100%;
	max-width: 20rem;
	margin: auto;
	vertical-align: center;
`;

export const Divider = styled.div`
	width: 100%;
	border-bottom: 1px solid ${palette('gray2')};
	margin: 2rem 0;
`;

export const PartnerButton = styled(Button)`
	border: 1px solid ${palette('black')};
`;

export const TextContainer = styled.div`
	margin: 2rem 0;

	&:first-of-type {
		margin-top: 0;
	}
`;
